import React from 'react';


function Input({ disabled, errors = {}, register, name, required, ...rest }) {
  const error = errors[name] ? true : false

  return (
    <React.Fragment>
      <input
        name={name}
        ref={register({ required })}
        className={`${error ? 'border-red-800' : ''} appearance-none bg-products border-2 px-4 py-3 pr-8 focus:outline-none focus:bg-white text-black w-full rounded-lg`}
        {...rest}
      />
      {error && 
        <span className="text-red-800">
          This field is required.
        </span>
      }
    </React.Fragment>
  );
}

export default Input;